import { Icon, IconButton, IconButtonProps } from '@chakra-ui/react';
import { IconType } from 'react-icons';

import { Replace } from '$utils/replace';

export function SidebarButton({
  onClick,
  icon,
  ...props
}: Replace<IconButtonProps, { icon: IconType }>) {
  return (
    <IconButton
      {...props}
      bg="transparent"
      color="text.primary"
      borderWidth="1px"
      borderColor="line.subtle"
      borderRadius="2px"
      fontSize="20px"
      h="40px"
      w="40px"
      minW="40px"
      icon={<Icon as={icon} />}
      onClick={onClick}
      _hover={{
        borderColor: 'accent.500',
        color: 'accent.500',
        bg: 'transparent',
      }}
      _active={{ bg: 'transparent' }}
    />
  );
}
